export default "__VITE_ASSET__CCaF$Uco__";